"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.VlpTableCarousel = void 0;
var _vlpTableCarousel = _interopRequireDefault(require("./components/vlp-table-carousel"));
exports.VlpTableCarousel = _vlpTableCarousel["default"];